import { Link } from "react-router-dom";
import { MapPin } from "lucide-react";
import { Reveal } from "@/components/site/Reveal";
import { SUBURBS } from "@/data/suburbs";

export default function AreasServed() {
  return (
    <section id="areas" data-testid="areas-section" className="relative bg-[#f8fafc] py-24 md:py-32 border-t border-[#0f172a]/10">
      <div className="mx-auto max-w-[1600px] px-6 md:px-12">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-8 mb-14">
          <div>
            <p className="overline !text-[#9c7a4d] mb-6 flex items-center gap-2">
              <MapPin className="h-3.5 w-3.5" /> Local to Perth
            </p>
            <h2 className="font-serif font-light text-[#0f172a] text-4xl sm:text-5xl lg:text-6xl leading-[0.98] tracking-tight">
              <Reveal>Areas we</Reveal>
              <Reveal delay={0.08}>serve.</Reveal>
            </h2>
          </div>
          <p className="text-[#475569] max-w-sm font-light">
            Precision tiling across Perth's premier suburbs — explore your area for local service details.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-px bg-[#0f172a]/10 border border-[#0f172a]/10">
          {SUBURBS.map((s) => (
            <Link
              key={s.slug}
              to={`/tiling/${s.slug}`}
              data-testid={`area-link-${s.slug}`}
              className="group bg-[#f8fafc] hover:bg-white px-6 py-8 transition-colors"
            >
              <span className="font-serif text-2xl md:text-3xl text-[#0f172a] group-hover:text-[#9c7a4d] transition-colors">{s.name}</span>
              <span className="block overline !text-[#94a3b8] mt-2 group-hover:!text-[#64748b] transition-colors">Tiling in {s.name}</span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
